<template>
  <landing-page
    label="covid19.covid19"
    description="covid19.introDesc"
    labelColor="#1687A7"
    descColor="#4E4E4E"
    :eggImgObj="{ componentName: 'covid19', imgName: 'covid19Intro', imgFormat: 'svg' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconLightSeaBlueRight', imgFormat: 'svg' }"
    class="mb-10"
  />
</template>

<script setup lang="ts">
import { useCovid19Store } from "@/stores/covid19";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const covid19Store = useCovid19Store();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>